import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Arrow icons for navigation

// Card component
const Card = ({ title, description, hovered, onMouseEnter, onMouseLeave }) => {
  return (
    <div
      className="card"
      onMouseEnter={() => onMouseEnter(title)} // Trigger on hover
      onMouseLeave={onMouseLeave} // Reset when mouse leaves
    >
      <div className="card-content">
        <h3 style={{ display: hovered ? 'none' : 'block' }}>{title}</h3> {/* Hide title on hover */}
        <p style={{ display: hovered ? 'block' : 'none', color: '#fff' }}>{description}</p> {/* Show description in white color on hover */}
      </div>
      <style jsx>{`
        .card {
          width: 350px;
          height: 150px;
          padding: 20px;
          margin: 10px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 6px 24px rgba(0, 0, 0, 0.1);
          text-align: center;
          background-color: #fff;
          transition: transform 0.3s ease, background-color 0.3s ease;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .card-content {
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .card:hover {
          transform: scale(1.05);
          background-color: #038499;
          color: white;
        }

        h3 {
          font-size: 22px;
          color: #333;
          margin: 0;
        }

        p {
          font-size: 16px;
          color: #fff; /* Set description color to white */
        }
      `}</style>
    </div>
  );
};

// Main component with Slick Slider and Auto-scrolling functionality
const AboutqualityCertificatecards = () => {
  const [hovered, setHovered] = useState(null); // Track the hovered card
  const sliderRef = useRef(null); // Ref to control slider programmatically

  // Settings for the slick slider with auto-scrolling enabled
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Function to manually scroll to the next slide
  const goToNextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  // Function to manually scroll to the previous slide
  const goToPrevSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <div className="app-container" style={{ background: '#fff' }}>
      <br />
      <h2>
        Quality <span style={{ color: 'rgb(1 135 159)' }}>Certifications</span>
      </h2>
      <p>We have earned the following international quality models and certifications.</p><br />

      {/* Slick Slider */}
      <Slider {...sliderSettings} ref={sliderRef} className="cards-slider">
        <Card
          title="ISO / IEC 27001 : 2014"
          description="This certification demonstrates our commitment to managing sensitive company information and ensuring data security."
          hovered={hovered === 'ISO / IEC 27001 : 2014'}
          onMouseEnter={setHovered}
          onMouseLeave={() => setHovered(null)}
        />
        <Card
          title="AS9100 : 2015"
          description="AS9100 certification reflects our ability to meet aerospace industry standards for quality management systems."
          hovered={hovered === 'AS9100 : 2015'}
          onMouseEnter={setHovered}
          onMouseLeave={() => setHovered(null)}
        />
        <Card
          title="IRIS3200 : 2017"
          description="This certification shows our competence in the rail industry, ensuring high-quality manufacturing and services."
          hovered={hovered === 'IRIS3200 : 2017'}
          onMouseEnter={setHovered}
          onMouseLeave={() => setHovered(null)}
        />
      </Slider>

      {/* Button Container for Manual Navigation */}
      <div className="buttons-container">
        <button onClick={goToPrevSlide} className="arrow-button prev-button">
          <FaArrowLeft />
        </button>
        <button onClick={goToNextSlide} className="arrow-button next-button">
          <FaArrowRight />
        </button>
      </div>

      <style jsx>{`
        .app-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: #f4f4f4;
          padding: 20px;
        }

        .cards-slider {
          margin-bottom: 40px;
          width: 80%;
        }

        .buttons-container {
          display: flex;
          justify-content: center;
          gap: 20px;
        }

        button {
          padding: 10px 20px;
          background-color: #11a1b0;
          color: white;
          border: none;
          border-radius: 31px;
          cursor: pointer;
          transition: background-color 0.3s;
        }

        button:hover {
          background-color: #0c7f86;
        }
      `}</style>
    </div>
  );
};

export default AboutqualityCertificatecards;
